/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseSignupSurvey } from '../../models/api-response-signup-survey';
import { SignupSurvey } from '../../models/signup-survey';

export interface SubmitSignUpSurvey$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  'X-Forwarded-For'?: string;
  reference: string;
      body: SignupSurvey
}

export function submitSignUpSurvey(http: HttpClient, rootUrl: string, params: SubmitSignUpSurvey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSignupSurvey>> {
  const rb = new RequestBuilder(rootUrl, submitSignUpSurvey.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.header('X-Forwarded-For', params['X-Forwarded-For'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseSignupSurvey>;
    })
  );
}

submitSignUpSurvey.PATH = '/v1/api/ui/public/sign-up/survey/{reference}';
